export class LoadPersonCustomerEntity {

    id: number
    personId: number;
    customerId: number;

constructor (){}
}
